<template>
  <div class="wrapper mt-3">
    <h2>Remote Service</h2>
    <div class="container mb-3">
      <div role="toolbar" class="btn-toolbar d-flex justify-content-between">
        <button @click="registerService()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Registrieren</button>
        <button @click="unregisterService()" class="btn btn-danger"><font-awesome-icon icon="trash"/>&nbsp;L&ouml;schen</button>
      </div>
      <div class="row mt-3">
        <div class="col-md">
          <h4>Service</h4>
          <div class="form-group">
            <label>Name</label>
            <input type="text" class="form-control" v-model="service.name"/>
          </div>
          <div class="form-group">
            <label>Key</label>
            <input type="text" class="form-control" v-model="service.key"/>
          </div>
          <div class="form-group">
            <label>Beschreibung</label>
            <textarea class="form-control" v-model="service.description">
            </textarea>
          </div>
          <div class="form-group">
            <label>URL</label>
            <input type="text" class="form-control" v-model="service.url"/>
          </div>
          <div class="form-group">
            <label>Type</label>
            <select class="form-control" v-model="service.type">
              <option value="0">Lokal</option>
              <option value="1">Online</option>
              <option value="2">Online (Third Party)</option>
            </select>
          </div>
          <div v-if="service.type == '0'" class="wrapper">
            <h3>Service Kommando</h3>
            <div class="form-group">
              <label>Befehl</label>
              <input v-model="command.command" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label>Arbeitsverzeichnis</label>
              <input v-model="command.workingDir" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="col-md">
          <h4>Anmeldung</h4>
          <div class="form-group">
            <label>Authentication</label>
            <select class="form-control" v-model="service.authType">
              <option value="">None</option>
              <option value="header_token">Header Token</option>
            </select>
          </div>
          <!-- header token configs -->
          <div v-if="service.authType == 'header_token'" class="wrapper">
            <div class="form-group">
              <label>Header</label>
              <input type="text" class="form-control" v-model="service.authInfo.header"/>
            </div>
            <div class="form-group">
              <label>Token-Key</label>
              <input type="text" class="form-control" v-model="service.authInfo.tokenref"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="remWarn" v-b-modal.modal-center :header-bg-variant="danger" title="Service entfernen" @ok="removeService">
      <p>
        Möchten Sie wirklich den angegebenen Service entfernen? Es werden keine Aufrufe mehr innerhalb von BusinessFlows oder Prozessen mehr möglich sein und sollten somit nicht mehr benutzt werden.
      </p>
    </b-modal>
  </div>
</template>

<script>
import router from '@/router'
import config from '@/modules/config.js'
import remoteservices from '@/modules/remoteservices.js'

export default {
  data() {
    return {
      service: { authInfo: {} },
      command: {},
    }
  },
  created() {
    if (this.$route.params.id != 'new') {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      var self = this;
      fetch(config.baseUrl + 'rest/remoteservices/services/' + encodeURIComponent(this.$route.params.id)).then(resp => resp.json()).then(function(data) {
        data.authInfo = data.authInfo || {};
        self.service  = data;
      })
    },
    // register a new service or update
    registerService() {
      console.log('register',this.service);
      // check to attach service command
      if (this.service.type == 1) {
          this.service.command = this.command;
      }
      var self = this;
      fetch(config.baseUrl + 'rest/remoteservices/services',{ method: 'POST', body: JSON.stringify(this.service), credentials: 'include'}).then(resp => resp.json()).then(function() {
        self.$bvToast.toast('Service registriert.',{variant: 'success', title:'Remote Services'});
      }).catch (err => {
        console.error('Failed to register service: ',err);
        this.$bvToast.toast('Serviceregistrierung fehlgeschlagen: ' + err + '.',{variant: 'danger', title:'Remote Services'});
      })
    },
    // unregister the current service
    unregisterService() {
      console.log('unregister');
      this.$bvModal.show("remWarn");
    },
    removeService() {
      remoteservices.remove(this.service.key).then(function() {
        router.push({name: 'RemoteServiceList' });
      }).catch(err => {
        console.error(err);
      })
    }
  }
}
</script>
